module.exports = __webpack_public_path__ + "img/p140.b042d0f7.jpg";